import Vue from "vue"
const vm = new Vue()
const context_line = JSON.parse(localStorage.getItem('context_line'))
const access_token = localStorage.getItem('access_token_line')

export function switchLiff(queryparam, size, redirectPath) {
    const bodyrequest = {
      access_token: access_token,
      temp_liff_id: context_line.liffId,
      size: size
    }
    vm.$http.post(vm.$API_URL + `/line/switch/size/${context_line.liffId}`, bodyrequest).then((res) => {
      const status = res.data.status
      if(status) {
          const response = res.data.data
          const liffIdSwitch = response.line_liff_id
          const queryParamsend = queryparam ? `&queryparams=${queryparam}` : ''

          vm.$liff.openWindow({
            url: `https://liff.line.me/${liffIdSwitch}?liffId=${liffIdSwitch}&redirectPath=${redirectPath}`+queryParamsend,
            external: false,
          })
      }
    })
}

export function formatLiff(liffId, redirectPath, queryParamsend) {
    return `https://liff.line.me/${liffId}?liffId=${liffId}&redirectPath=${redirectPath}`+ queryParamsend
}